<flexyoo-generic-page-with-logo>
  <ng-container content>
    <div class="flexyoo-login-form">
      <div>
        <div>{{ 'both-languages.hello' | translate }} {{ name }},</div>
        <br />
        <div>{{ 'both-languages.choose-username-and-password' | translate }}.</div>
      </div>
      <form id="LoginForm" [formGroup]="form" (ngSubmit)="onSubmit()">
        <mat-form-field>
          <input formControlName="email" matInput type="text" [readonly]="true" />
        </mat-form-field>
        <mat-form-field>
          <mat-label>{{ 'both-languages.password' | translate }}</mat-label>
          <input formControlName="password" matInput type="password" />
        </mat-form-field>
        @if (form.controls.password.errors?.notEnoughCharacters) {
          <mat-error>{{ 'auth.password-requirements.characters-length' | translate }} </mat-error>
        }
        @if (form.controls.password.errors?.noDigit) {
          <mat-error>{{ 'auth.password-requirements.digits' | translate }}</mat-error>
        }
        @if (form.controls.password.errors?.noLower) {
          <mat-error>{{ 'auth.password-requirements.lower-case' | translate }}</mat-error>
        }
        @if (form.controls.password.errors?.noUpper) {
          <mat-error>{{ 'auth.password-requirements.upper-case' | translate }}</mat-error>
        }
        <mat-form-field>
          <mat-label>{{ 'auth.confirm-password' | translate }}</mat-label>
          <input formControlName="confirmPassword" matInput type="password" />
        </mat-form-field>
        @if (form.controls.confirmPassword.errors?.noPasswordMatch) {
          <mat-error> {{ 'auth.no-password-match' | translate }}</mat-error>
        }
        <button
          matButton="filled"
          style="display: block; font-size: 20px; margin: 10px auto 0"
          type="submit"
          [disabled]="!form.enabled" class="fo-color-secondary"
        >
          {{ 'both-languages.confirm' | translate }}
        </button>
      </form>
    </div>
  </ng-container>
</flexyoo-generic-page-with-logo>
